 App.service('CITY', ['API',function(API) {
     this.fatafat = function () {
         // data.token = localStorage.getItem(accessTokenGlobal);
        return API.get(menu_base_url + 'website/get_cities').then(function (result) {
             if (result.data.flag == 143) {
                 return result.data.cities;
             }
         })
     }
     this.rides = function (){
       return  API.get('https://api-panels.jugnoo.in:8020/get_city_info').then(function(result) {
         return result.data.data;
     })
     }
 }]);
